// import * as classes from './App.scss';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { RouteDefinitions } from '@common/route-definitions';

class TableOfContents extends React.Component {
  render() {
    return (
      <div className="row middle-xs center-xs">
        <div className="col-md-12">
          <p>
            <Link to={RouteDefinitions.profile.Create}>Profile</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.realestateagent.Create}>Real Estate Agent</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.realestateagent.Search}>Real Estate Agent Search</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.customer.Create}>Customer</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.customer.Search}>Customer Search</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.escrowofficer.Search}>Escrow Officer Search</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.escrowofficer.Create}>Escrow Officer</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.transactioncoordinator.Search}>Transaction Coordinator Search</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.transactioncoordinator.Create}>Transaction Coordinator and Assistants</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.escrowoffice.Search}>Escrow Office Search</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.escrowoffice.Create}>Escrow Office</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.realestateoffice.Create}>Real Estate Office</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.realestateoffice.Search}>Real Estate Office Search</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.propertymanager.Edit}>Property Manager</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.user.List}>User Administration</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.contract.Create}>Contract</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.cilNotification.Notification + '?swoTrackingCILOfferId=1&contractId=1395694'}>
              CIL Notification
            </Link>
          </p>
          <p>
            <Link to={RouteDefinitions.autoautho}>Auto Autho</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.quote.Create}>Quote</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.quote.Search}>Quote Search</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.propertymanagementoffice.Create}>Property Management Office</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.propertymanager.Create}>Property Manager</Link>
          </p>
          <p>
            <Link to={RouteDefinitions.accounting.List}>Accounting List</Link>
          </p>
        </div>
      </div>
    );
  }
}

export default TableOfContents;



// WEBPACK FOOTER //
// ./src/table-of-contents/table-of-contents.tsx